
import { getTypoCSS, getColorsCSS } from '../../Components/Helper/getCSS';
import { getBoxValue } from './Const/functions';
import arrows from './Const/arrows';

const Style = ({ attributes, clientId }) => {
	const { slideInnerGap, titleTypo, titleColor, descTypo, descColor, titleMargin, descMargin, arrow, arrowStyle, indicator, SliderOverly, height, borderRadius, margin, arrowWidth, arrowHeight, arrowRadius, btnColors, btnHovColors, btnTypo, btnPadding, btnBorder, btnRadius, direction, titleAnimation, descAnimation, btnAnimation } = attributes;

	// if (indicator.direction === "vertical" && (indicator)) {
	// }
	// const isParsent = indicator.moveFromEdge?.includes('%');
	// if (isParsent) {
	// 	const number = parseFloat(indicator.moveFromEdge.slice(0, -1));
	// 	const vag = (number / 100) * indicator.width;
	// 	console.log(vag);
	// }

	return <style dangerouslySetInnerHTML={{
		__html: `
	${getTypoCSS(titleTypo)?.googleFontLink ? `@import url(${getTypoCSS(titleTypo)?.googleFontLink});` : ''}
	${getTypoCSS(descTypo)?.googleFontLink ? `@import url(${getTypoCSS(descTypo)?.googleFontLink});` : ''}
	${getTypoCSS(btnTypo)?.googleFontLink ? `@import url(${getTypoCSS(btnTypo)?.googleFontLink});` : ''}

	#bsbCarousel-${clientId} .bsbCarousel {
		margin:${getBoxValue(margin)};
	}

	#bsbCarousel-${clientId} h5{
		${getTypoCSS(titleTypo)?.styles}
		color: ${titleColor};
		margin: ${getBoxValue(titleMargin)};
		animation-delay: ${titleAnimation?.delay}s;
		animation-duration: ${titleAnimation?.duration}s;
	}

	#bsbCarousel-${clientId} p {
		${getTypoCSS(descTypo)?.styles}
		color: ${descColor};
		margin: ${getBoxValue(descMargin)}; 
		animation-delay: ${descAnimation?.delay}s;
		animation-duration: ${descAnimation?.duration}s;
	}

	#bsbCarousel-${clientId} .carousel-button {
		animation-delay: ${btnAnimation?.delay}s;
		animation-duration: ${btnAnimation?.duration}s;
	}

	#bsbCarousel-${clientId} .carousel-button a {
		${getTypoCSS(btnTypo)?.styles};
		${getColorsCSS(btnColors)};
		padding: ${getBoxValue(btnPadding || {})};
		border: ${getBoxValue(btnBorder || {})};
		border-radius: ${btnRadius};
		transition:0.3s;
	}

	#bsbCarousel-${clientId} .carousel-button a:hover {
		${getColorsCSS(btnHovColors)};
		transition:0.3s;
	}

	#bsbCarousel-${clientId} .carousel-item {
		position:relative;
		height: ${height};
		border-radius: ${getBoxValue(borderRadius)};
		box-sizing: border-box;
		overflow: hidden;
	}

	#bsbCarousel-${clientId} .bsbButtonDesign .bsbArrowButton {
		${getColorsCSS(arrow)};
		font-size:${arrow?.size}px;
		width:${arrowWidth};
		height:${arrowHeight};
		border-radius:${getBoxValue(arrowRadius)};
	}

	#bsbCarousel-${clientId} .carousel-item:after{
		content: '';
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background: ${SliderOverly};
	}

	#bsbCarousel-${clientId} .carousel-item .carousel-caption {
		width:calc(100% - ${slideInnerGap});
	}

	#bsbCarousel-${clientId} .carousel-indicators {
		flex-direction: ${"vertical" === indicator?.direction ? 'column' : 'row'};
	}

	#bsbCarousel-${clientId} .carousel-indicators button{
		width: ${indicator?.width} !important;
		height: ${indicator?.height} !important;
		background-color:${indicator.color};
		border: ${indicator?.border?.width || '0px'} solid transparent;
		border-radius: ${indicator?.radius};
		transform: translateY(${indicator?.moveFromEdge});
	}
	#bsbCarousel-${clientId} .carousel-indicators button.active{
		background-color:${indicator?.activeColor};
		border: ${getBoxValue(indicator?.activeBorder || {})};
	}
	#bsbCarousel-${clientId} .carousel-indicators.vertical button {
		transform: translateX(${indicator.moveFromEdge});
	}

	#bsbCarousel-${clientId} .arrowMouseEffect .carousel-control-prev:hover{
		cursor: url("data:image/svg+xml;utf8,${arrows[arrowStyle].left(arrow?.size, arrow?.color, direction)}"), default;
	}

	#bsbCarousel-${clientId} .arrowMouseEffect .carousel-control-next:hover{
		cursor: url("data:image/svg+xml;utf8,${arrows[arrowStyle].right(arrow?.size, arrow?.color, direction)}"), default;
	}

	`.replace(/\s+/g, ' ')
	}} />
}
export default Style;